import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useState, useMemo, useCallback } from "react";
import classnames from "classnames";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/PaymentSelect.module.scss";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import { HiddenField } from "@/components/Form/Parts/index";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import PaymentRadioButton from "./PaymentRadioButton";
import { useAdultModeQuery } from "@/hooks";
import { IGNORE_PAYPAY, CREATE_ONLY_MODE } from "./index";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PaymentInstrumentsList(_ref) {
  var mode = _ref.mode,
      paymentInstruments = _ref.paymentInstruments,
      register = _ref.register,
      onChange = _ref.onChange;
  if (CREATE_ONLY_MODE.includes(mode)) return null;
  if (!paymentInstruments) return null;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useAdultModeQuery.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;

  var _useState = useState(0),
      selectPaymentInstrument = _useState[0],
      setSelectPaymentInstrument = _useState[1]; // 支払い方法ごとに分ける


  var creditCard = useMemo(function () {
    return paymentInstruments.filter(function (v) {
      return v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD;
    });
  }, [paymentInstruments]);
  var paypay = useMemo(function () {
    return paymentInstruments.filter(function (v) {
      return !IGNORE_PAYPAY.includes(mode) && v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY;
    });
  }, [paymentInstruments]);
  var carrier = useMemo(function () {
    return paymentInstruments.filter(function (v) {
      return [PAYMENT_METHOD_ID.AU, PAYMENT_METHOD_ID.DOCOMO, PAYMENT_METHOD_ID.SOFTBANK].includes(v.payment_method_id);
    });
  }, [paymentInstruments]);
  var handleClick = useCallback(function (id) {
    return function () {
      return setSelectPaymentInstrument(Number(id));
    };
  }, []);
  var handleChange = useCallback(function (e) {
    onChange({
      paymentMethod: e.target.value,
      createPayment: false,
      showInput: false
    });
  }, []);
  var cardNumber = useCallback(function (v) {
    return " ****-****-****-" + v.values.card_number;
  }, []);
  var labelClassName = useCallback(function (v) {
    var _v$values, _classnames;

    var cardType = v === null || v === void 0 ? void 0 : (_v$values = v.values) === null || _v$values === void 0 ? void 0 : _v$values.card_type;
    return classnames(styles.radioCheck, styles.paymentMethodIcon, (_classnames = {}, _defineProperty(_classnames, styles.visa, cardType === "visa"), _defineProperty(_classnames, styles.jcb, cardType === "jcb"), _defineProperty(_classnames, styles.master, cardType === "mastercard"), _defineProperty(_classnames, styles.amex, cardType === "amex"), _defineProperty(_classnames, styles.diners, cardType === "dinersclub"), _defineProperty(_classnames, styles.paypay, v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY), _defineProperty(_classnames, styles.docomo, v.payment_method_id === PAYMENT_METHOD_ID.DOCOMO), _defineProperty(_classnames, styles.softbank, v.payment_method_id === PAYMENT_METHOD_ID.SOFTBANK), _defineProperty(_classnames, styles.au, v.payment_method_id == PAYMENT_METHOD_ID.AU), _classnames));
  }, []);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: "".concat(formStyles.marginOff, " ").concat(styles.paymentInstrumentsListFieldset),
    children: [/*#__PURE__*/_jsx("p", {
      className: styles.paymentInstrumentsListFieldsetTitle,
      children: "\u3054\u767B\u9332\u6E08\u307F\u306E\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u5229\u7528\u3059\u308B"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.paymentInstrumentStyle,
      children: [creditCard && /*#__PURE__*/_jsx(_Fragment, {
        children: creditCard.map(function (v) {
          return /*#__PURE__*/_jsx(PaymentRadioButton, {
            ref: register,
            paymentMethodId: v.payment_method_id,
            id: "paymentInstrumentId".concat(v.payment_instrument_id),
            className: labelClassName(v),
            value: v.payment_method_id,
            onChange: handleChange,
            onClick: handleClick(v.payment_instrument_id),
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.iconWithText,
              children: [/*#__PURE__*/_jsx(PaymentIconImage, {
                large: true,
                paymentMethodId: v.payment_method_id,
                cardType: v.values.card_type,
                className: styles.cardImage
              }), /*#__PURE__*/_jsx("span", {
                className: styles.paymentCreditCardText,
                children: v.payment_method.name
              }), /*#__PURE__*/_jsx("span", {
                className: styles.paymentCreditCardText,
                children: cardNumber(v)
              })]
            })
          }, "paymentInstrument-".concat(v.payment_instrument_id));
        })
      }), paypay && /*#__PURE__*/_jsx(_Fragment, {
        children: paypay.map(function (v) {
          return /*#__PURE__*/_jsx(PaymentRadioButton, {
            ref: register,
            paymentMethodId: v.payment_method_id,
            id: "paymentInstrumentId".concat(v.payment_instrument_id),
            className: labelClassName(v),
            value: v.payment_method_id,
            onChange: handleChange,
            onClick: handleClick(v.payment_instrument_id),
            disabled: adultMode,
            children: /*#__PURE__*/_jsx(PaymentIconImage, {
              large: true,
              paymentMethodId: v.payment_method_id,
              cardType: v.values.card_type
            })
          }, "paymentInstrument-".concat(v.payment_instrument_id));
        })
      }), carrier && /*#__PURE__*/_jsx("div", {
        className: styles.carrierPayments,
        children: carrier.map(function (v) {
          return /*#__PURE__*/_jsx(PaymentRadioButton, {
            ref: register,
            paymentMethodId: v.payment_method_id,
            id: "paymentInstrumentId".concat(v.payment_instrument_id),
            className: labelClassName(v),
            value: v.payment_method_id,
            onChange: handleChange,
            onClick: handleClick(v.payment_instrument_id),
            disabled: adultMode,
            children: /*#__PURE__*/_jsx(PaymentIconImage, {
              large: true,
              paymentMethodId: v.payment_method_id,
              cardType: v.values.card_type
            })
          }, "paymentInstrument-".concat(v.payment_instrument_id));
        })
      }), /*#__PURE__*/_jsx(HiddenField, {
        ref: register,
        name: "paymentInstrument",
        value: selectPaymentInstrument
      })]
    })]
  });
}